import { render } from "./EmergenciesComponent.vue?vue&type=template&id=5e115281"
import script from "./EmergenciesComponent.vue?vue&type=script&lang=js"
export * from "./EmergenciesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__